export default function (random) {
  return (random() - 0.5) * 1e-6;
}